import html2pdf from 'html2pdf.js'
import React from 'react';

import Image from '../../assets/images/HomePage/landing.png';
import './PdfContent.css';

const fillPages = (list, numRows = 30) => {
    const bookList = [...list].reverse()
    if (bookList.length < numRows) {
        return bookList.concat(Array(numRows - list.length).fill({}))
    }
    return bookList;
}

// first page is shorter, all others should be roughly the same
const shouldPageBreak = (rowNum, breakNum) => rowNum === breakNum ||
    (rowNum > breakNum && ((rowNum - breakNum) % 18 === 0));

const TableHeaderRow = (props) => {
    return props.isReadingLog?
        <div className="pdf-row pdf-header">
            <div className="pdf-cell">PRC&nbsp;ID</div>
            <div className="pdf-cell">Title</div>
            <div className="pdf-cell">Author</div>
            <div className="pdf-cell"> </div>
            <div className="pdf-cell"> </div>
        </div> :
        <div className="pdf-row pdf-header pdf-row--savedBooks">
            <div className="pdf-cell">Title</div>
            <div className="pdf-cell">Author</div>
        </div>
}

const TableBookRow = ({book, isReadingLog}) => {
    const bookid = book.bookId? book.bookId.toString() : '';
    return isReadingLog ?
        <div className="pdf-row">
            <div className="pdf-cell">{bookid.startsWith('pcb')? '' : bookid}</div>
            <div className="pdf-cell">{book.title}</div>
            <div className="pdf-cell">{book.author}</div>
            <div className="pdf-cell" />
            <div className="pdf-cell" />
        </div> :
        <div className="pdf-row pdf-row--savedBooks">
            <div className="pdf-cell">{book.title}</div>
            <div className="pdf-cell">{book.author}</div>
        </div>
}

const pdfContentId = "pdfContent";

const currentDate = new Date().toLocaleString('en-AU', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
})

const SavedBooksPdf = ({studentName, watchList = [] }) => (
    <div id={pdfContentId}>
        <div className="header-section">
            <div className="header-section-savedBooks">
                <span>{currentDate}</span>
                <h1>{studentName}'s Saved Books</h1>
                <h3>NSW Premier's Reading Challenge</h3>
                <hr/>
            </div>
        </div>
        <div className="table-section">
            <TableHeaderRow isSavedBooks />
            {
                fillPages(watchList, 20).map((book, i) =>
                    <React.Fragment key={i}>
                        {
                            shouldPageBreak(i, 20) ?
                                <React.Fragment>
                                    <div className="html2pdf__page-break" />
                                    <TableHeaderRow isSavedBooks />
                                </React.Fragment> :
                                null
                        }
                        <TableBookRow isSavedBooks book={book} />
                    </React.Fragment>
                )
            }
        </div>
    </div>
);

const ReadingLogPdf = ({studentName, readList = [], isHighGrade}) => {
    const numToComplete = isHighGrade? 20 : 30;
    const bookList = readList.length > numToComplete? readList.slice(0, numToComplete) : readList;
    return  <div id={pdfContentId}>
                <div className="header-section">
                    <img src={Image} alt="" className="header-image" />
                    <div className="header-sidebar">
                        <div className="name-header">This is the personal reading log of :</div>
                        <div className="name-field">{studentName}</div>
                        <div>
                            <div className="list-item">
                                <div>&#9675;</div>
                                <div>
                                    To make sure you are reading the right books, please check the rules for your Challenge on the website:
                                    {' '}
                                    <a href="http://online.det.nsw.edu.au/prc/home.html">http://online.det.nsw.edu.au/prc/home.html</a>
                                </div>
                            </div>
                            <div className="list-item">
                                <div>&#9675;</div>
                                <div>
                                    Student Reading Records must be entered online.
                                    Online entries are available between March and August.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="header-bottom">
                    <div className="list-item">
                        <div>&#9675;</div>
                        <div>You can use the last two columns here to record the date or to have books signed off when you read them.</div>
                    </div>
                </div>
                <div className="table-section">
                    <TableHeaderRow isReadingLog />
                    {
                        fillPages(bookList).map((book, i) =>
                            <React.Fragment key={i}>
                                {
                                    shouldPageBreak(i, 14) ?
                                        <React.Fragment>
                                            <div className="html2pdf__page-break" />
                                            <TableHeaderRow isReadingLog />
                                        </React.Fragment> :
                                        null
                                }
                                <TableBookRow isReadingLog book={book} />
                            </React.Fragment>
                        )
                    }
                </div>
            </div>
}

// TODO: investigate jsPDF autotable for managing multi-page table
const PdfContent = (props) => {
    const {tabValue} = props;
    const isWatchList = tabValue === 0
    return isWatchList ?
        <SavedBooksPdf {...props} /> :
        <ReadingLogPdf {...props} />;
}

const pad = (x) => x < 10 ? `0${x}` : x;
const formatDate = (date) => {
    const d = date.getDate();
    const m = date.getMonth() + 1;
    const y = date.getFullYear();
    const h = date.getHours() > 12 ? date.getHours() % 12 : date.getHours();
    const mins = date.getMinutes();
    const s = date.getSeconds();
    const a = date.getHours() >= 12 ? 'pm' : 'am';

     // h is deliberately not padded to match localestring behaviour
    return `${pad(d)}/${pad(m)}/${y}, ${h}:${pad(mins)}:${pad(s)} ${a}`;
}

export const savePdf = (filename, label) => {
    const element = document.getElementById(pdfContentId);

    // used to add a consistent footer to every page in the PDF
    const pdfCallback = (pdf) => {
        const pageCount = pdf.internal.getNumberOfPages();
        const pageSize = pdf.internal.pageSize;

        pdf.setFontSize(12);

        for (let i = 1; i <= pageCount; i++) {
            pdf.setPage(i);
            const footer = `Page ${i} / ${pageCount}`;
            const date = formatDate(new Date());
            const savedBookFooterText = `Next step: Add these books to your Online Reading Log after you've read them`
            const footerMargin = 10;
            const labelWidth = pdf.getTextWidth(label);
            const footerWidth = pdf.getTextWidth(footer) + 10;
            const pageBottom = pageSize.height - footerMargin;
            const footerLineY = pageBottom - 6;
            pdf.setLineWidth(0.4);
            if(label === 'Saved Books'){
                pdf.text(savedBookFooterText, 10, pageBottom - footerMargin);
            }
            pdf.line(10, footerLineY, pageSize.width - 10, footerLineY);
            // bottom right: page numbering
            pdf.text(footer, pageSize.width - footerWidth, pageBottom);
            if(label !== 'Saved Books'){
                // bottom left: date
                pdf.text(date, 10, pageBottom);
                // bottom center: label (e.g. 'Saved Books' or 'Personal Reading Log')
                pdf.text(label, (pageSize.width - labelWidth) / 2, pageBottom);
            }
        }
        pdf.save(filename);
    };

    html2pdf(element, {
        margin: 10,
        filename,
        html2canvas:  { dpi: 192 }, // decent quality to file size ratio
        pdfCallback
    });
}

export default PdfContent;
